import React from 'react';
import { Edit3, Lock, Check } from 'lucide-react';
import type { VersionStatus, StatusPillProps } from '../../types';
import { STATUS_CONFIG } from '../../types';

const StatusIcon: Record<VersionStatus, React.ReactNode> = {
  Draft: <Edit3 size={12} />,
  Locked: <Lock size={12} />,
  Published: <Check size={12} />,
};

export function StatusPill({ status, size = 'md' }: StatusPillProps) {
  const config = STATUS_CONFIG[status];

  const sizeClasses = size === 'sm'
    ? 'px-1.5 py-0.5 text-[10px]'
    : 'px-2 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium rounded-full border ${config.bgColor} ${config.color} ${config.borderColor} ${sizeClasses}`}
    >
      {StatusIcon[status]}
      {status}
    </span>
  );
}

export default StatusPill;
